/* eslint-disable camelcase */
import React, { useEffect } from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Stack } from '@mui/material'
import i18n from 'simple-react-i18n'
import PGSSEFilters from '../common/PGSSEFilters'
import { NewTable } from 'components/datatable/NewTable'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { push } from '@lagunovsky/redux-react-router'
import { PATH_PGSSE } from 'home/constants/RouteConstants'
import { nbPerPageLabelHuge } from 'referencial/constants/ReferencialConstants'
import { getLabel } from 'utils/StoreUtils'
import useTitle from 'utils/customHook/useTitle'
import { map } from 'lodash'
import PgsseAction from 'pgsse/action/PgsseAction'

const ActionList = () => {
    const {
        contributors,
        distributionUnits,
        sectors,
        diagnosticActions,
    } = useSelector(store => ({
        contributors: store.ContributorReducer.contributors,
        distributionUnits: store.DistributionUnitReducer.distributionUnits,
        sectors: store.SectorReducer.sectors,
        diagnosticActions: store.PgsseReducer.diagnosticActions,
    }), shallowEqual)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(PgsseAction.fetchDashboardPhase3List({}))
    }, [])

    useTitle(() => [{
        title: i18n.pgsse,
        href: PATH_PGSSE,
    }, {
        title: i18n.phase3,
        href: `${PATH_PGSSE}/phase3`,
    }], [])

    const actionsByYear = diagnosticActions
        .map(d => {
            const nbCreation = d.nbCreation || 0
            const nbUpdate = d.nbUpdate || 0
            const nbResolved = d.nbResolved || 0
            return {
                ...d,
                collectivity: getLabel(contributors, d.idContributor),
                sector: getLabel(sectors, d.idSector),
                udiCode: getLabel(distributionUnits, d.idUdi, 'code'),
                udi: getLabel(distributionUnits, d.idUdi),
                nbUpdate,
                nbResolved,
                nbCreation,
                total: nbUpdate + nbResolved + nbCreation,
            }
        })
        .reduce((acc, item) => {
            (acc[item.year] ||= []).push(item)
            return acc
        }, {})

    const orderedAnnualActions = map(actionsByYear, (actions, year) => ({
        year,
        actions,
    })).sort((a, b) => b.year - a.year)

    return (
        <Stack spacing={1} sx={{ padding: '10 10 10 20' }}>
            <PGSSEFilters onValidate={filters => dispatch(PgsseAction.fetchDashboardPhase3List(filters))} />
            {orderedAnnualActions.map((annualActions, index) => (
                <Accordion defaultExpanded={index === 0} key={annualActions.year}>
                    <AccordionSummary>{annualActions.year}</AccordionSummary>
                    <AccordionDetails>
                        <NewTable
                            rows={annualActions.actions}
                            headers={['collectivity', 'sector', 'udiCode', 'udi',
                                { key: 'nbCreation', value: i18n.initiated },
                                { key: 'nbUpdate', value: i18n.inProgress },
                                { key: 'nbResolved', value: i18n.executed },
                                { key: 'total', value: i18n.total },
                            ]}
                            onClickRow={d => dispatch(push(`${PATH_PGSSE}/phase3/${d.idDiag}`))}
                            rowsPerPageOptions={nbPerPageLabelHuge}
                        />
                    </AccordionDetails>
                </Accordion>
            ))}
        </Stack>
    )
}

export default ActionList
